import { render, staticRenderFns } from "./ProgramProgramModuleCreateDetail.vue?vue&type=template&id=4d47c973"
import script from "./ProgramProgramModuleCreateDetail.vue?vue&type=script&lang=js"
export * from "./ProgramProgramModuleCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./ProgramProgramModuleCreateDetail.vue?vue&type=style&index=0&id=4d47c973&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports